import { environment } from './../../../../environment/environment';
import { CallOfferService } from './../../../core/services/call-offer-service/call-offer.service';
import { Component, TemplateRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { CreateCallOffer, IRequstJob } from './../../../core/models/call-offer';
import { calloffermodifie } from './../../../core/models/messages';
import { patternName } from './../../../core/models/pattern';
import { Country, IState, State } from 'country-state-city';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Subject, takeUntil } from 'rxjs';
import Swal from 'sweetalert2';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
const DOMPurify = require('dompurify');

@Component({
  selector: 'app-detailcallofferclientfinal',
  templateUrl: './detailcallofferclientfinal.component.html',
  styleUrls: ['./detailcallofferclientfinal.component.css'],
})
export class DetailcallofferclientfinalComponent {
  /* object */
  esnDetails: any;
  jobRequest!: IRequstJob;
  /* formGroup */
  callDetailsForm: FormGroup = this.DetailsForm();
  /* unsubscription */
  private unsubscribeAll: Subject<void> = new Subject();
  colorsHeader: string[] = [
    '#FBF2E9',
    '#E8F6FC',
    '#FDEFEE',
    '#FFF3D7',
    '#FBF2E9',
  ];
  /* short url */
  siteweb_link: any;
  shortenedUrl = '';
  call: any;
  url: string = environment.baseUrl + '/api';
  listReviewCompany: any;
  listDefaultReview: any;
  skills1: any;
  jobofferDetails: any;
  fileError: string = '';
  fileExtention: string = '';
  file: any;
  skillsList: { name_FR: string }[] = [];
  /* modal */
  modalRef?: BsModalRef;
  stateList: any = [];
  paysList: any[] = Country.getAllCountries().map((country) => ({
    ...country,
    name: this.translateCountryName(country.name),
  }));
  /* number */
  totalItems!: number;
  mobilities: any[] = [];

  itemsPerPage: number = 20;
  currentPage: number = 1;
  startIndex: number = 0;
  endIndex: number = 5;
  total_avg_stars: any;
  showBoxResponseCompany = false;
  showBoxDefaultResponse = true;
  id = this.activatedRoute.snapshot.params['id'];
  idCallOffer!: number;
  skills: any[] = [];
  countries: any = [];

  postType = [
    { id: '1', name: 'A distance' },
    { id: '2', name: 'Hybride' },
    { id: '3', name: 'Sur site' },
  ];
  contrat = [
    { id: '1', name: 'Alternance' },
    { id: '2', name: 'Autres type de contrat' },
    { id: '3', name: 'CDD' },
    { id: '4', name: 'CDI' },
    { id: '5', name: 'Freelance' },
    { id: '6', name: 'Portage salarial' },
    { id: '7', name: 'Stage' },
  ];
  descriptionColor: string = 'black'; 
  contratType = [
    { id: '1', name: 'Alternance' },
    { id: '2', name: 'Autres type de contrat' },
    { id: '3', name: 'CDD' },
    { id: '4', name: 'CDI' },
    { id: '5', name: 'Freelance' },
    { id: '6', name: 'Portage salarial' },
    { id: '7', name: 'Stage' },
  ];
  disponibilite = [
    { id: 1, name: 'Immédiate' },
    { id: 3, name: '2 mois' },
    { id: 4, name: '3 mois' },
    { id: 5, name: '4 mois' },
    { id: 6, name: '5 mois' },
  ];
  contractTypesList: { id: any; name: string }[] = [
    { id: '1', name: 'Alternance' },
    { id: '2', name: 'Autres type de contrat' },
    { id: '3', name: 'CDD' },
    { id: '4', name: 'CDI' },
    { id: '5', name: 'Freelance' },
    { id: '6', name: 'Portage salarial' },
    { id: '7', name: 'Stage' },
    // Ajoutez d'autres types de contrat au besoin
  ];
  createform: FormGroup = this.registerForm();

  constructor(
    private activatedRoute: ActivatedRoute,
    private callService: CallOfferService,
    private spinner: NgxSpinnerService,
    private toastr: ToastrService,
    private formBuilder: FormBuilder,
    private router: Router,
    private sanitizer: DomSanitizer,
    private modalService: BsModalService
  ) {}
  toolbarOptions = [
    ['bold', 'italic', 'underline'],
    [{ header: 1 }, { header: 2 }],
    [{ list: 'ordered' }, { list: 'bullet' }],
    [{ indent: '-1' }, { indent: '+1' }],
    [{ color: [] }, { background: [] }], 
    ['clean'],
  ];
  ngOnInit() {
    window.scrollTo(0, 0);
    this.getId();
    this.getskillsjoboffer();
    this.getListSkills();
  }
  registerForm(data?: any) {
    const defaultCallOffer: CreateCallOffer = {
      name: data ? data.name : '',
      post_type: data ? data.post_type : '',
      city: [[]],
      country: [[]],
      availability: data ? data.availability : '',
      salary: data ? data.salary : '',
      years_of_experience: data ? data.years_of_experience : '',
      contract_type: data ? data.contract_type : '',
      tjm: data ? data.tjm : '',
      description: data ? data.description : '',
      skills: data ? data.skills : [],
      dedicated_to: data ? data.dedicated_to : [],
      profile_abroad: data ? data.profile_abroad : '',
      passeport_talent: data ? data.passeport_talent : '',
      otherSkills: [[]],
    };

    return this.formBuilder.group({
      name: [
        data ? data.name : '',
        [Validators.required, Validators.pattern(patternName)],
      ],
      post_type: [data ? data.post_type : null],
      city: [data ? data.city : []],
      country: [data ? data.country : [], Validators.required],
      availability: [data ? data.availability : null],
      salary: [data ? data.salary : ''],
      years_of_experience: [
        data ? data.years_of_experience : '',
        Validators.required,
      ],
      contract_type: [data ? data.contract_type : []],
      tjm: [data ? data.tjm : ''],
      description: [data ? data.description : ''],
      skills: [data ? data.skills : []],
      otherSkills: [[]],
      dedicated_to: [data ? data.dedicated_to : [], Validators.required],
      profile_abroad: [data ? data.profile_abroad : '', Validators.required],
      passeport_talent: [
        data ? data.passeport_talent : '',
        Validators.required,
      ],
      role_id: 4,
    });
  }

  /* get id esn from route */
  getId() {
    this.activatedRoute.paramMap.subscribe({
      next: (params: any) => {
        this.id = params.params['id'];
        this.getCompanyById();
      },
    });
  }
  safeDescription!: SafeHtml;
  updateDescription(description: string) {
    this.safeDescription = this.sanitizer.bypassSecurityTrustHtml(description);
  }
  isNumeric(value: any): boolean {
    return !isNaN(parseFloat(value)) && isFinite(value);
  }
  formatDate(dateString: string): string {
    if (!dateString) return '---';

    const dateParts = dateString.split(' ')[0].split('-');
    if (dateParts.length !== 3) return dateString;

    const [year, month, day] = dateParts;
    return `${day}/${month}/${year}`;
  }

  translateCountryName(name: string): string {
    const translations: { [key: string]: string } = {
      Afghanistan: 'Afghanistan',
      'South Africa': 'Afrique du Sud',
      Albania: 'Albanie',
      Algeria: 'Algérie',
      Germany: 'Allemagne',
      Andorra: 'Andorre',
      Angola: 'Angola',
      Anguilla: 'Anguilla',
      Antarctica: 'Antarctique',
      'Antigua and Barbuda': 'Antigua-et-Barbuda',
      'Saudi Arabia': 'Arabie saoudite',
      Argentina: 'Argentine',
      Armenia: 'Arménie',
      Aruba: 'Aruba',
      Australia: 'Australie',
      Austria: 'Autriche',
      Azerbaijan: 'Azerbaïdjan',
      Bahamas: 'Bahamas',
      Bahrain: 'Bahreïn',
      Bangladesh: 'Bangladesh',
      Barbados: 'Barbade',
      Belgium: 'Belgique',
      Belize: 'Belize',
      Benin: 'Bénin',
      Bermuda: 'Bermudes',
      Bhutan: 'Bhoutan',
      Belarus: 'Biélorussie',
      Bolivia: 'Bolivie',
      'Bosnia and Herzegovina': 'Bosnie-Herzégovine',
      Botswana: 'Botswana',
      Brazil: 'Brésil',
      Brunei: 'Brunei',
      Bulgaria: 'Bulgarie',
      'Burkina Faso': 'Burkina Faso',
      Burundi: 'Burundi',
      'Cape Verde': 'Cabo Verde',
      Cambodia: 'Cambodge',
      Cameroon: 'Cameroun',
      Canada: 'Canada',
      Chile: 'Chili',
      China: 'Chine',
      Cyprus: 'Chypre',
      Colombia: 'Colombie',
      Comoros: 'Comores',
      'Congo - Brazzaville': 'Congo-Brazzaville',
      'Congo - Kinshasa': 'Congo-Kinshasa',
      'North Korea': 'Corée du Nord',
      'South Korea': 'Corée du Sud',
      'Costa Rica': 'Costa Rica',
      'Ivory Coast': 'Côte d’Ivoire',
      Croatia: 'Croatie',
      Cuba: 'Cuba',
      Curaçao: 'Curaçao',
      Denmark: 'Danemark',
      Djibouti: 'Djibouti',
      Dominica: 'Dominique',
      'Dominican Republic': 'République dominicaine',
      Ecuador: 'Équateur',
      Egypt: 'Égypte',
      'United Arab Emirates': 'Émirats arabes unis',
      Eritrea: 'Érythrée',
      Spain: 'Espagne',
      Eswatini: 'Eswatini',
      Estonia: 'Estonie',
      'United States': 'États-Unis',
      Ethiopia: 'Éthiopie',
      Fiji: 'Fidji',
      Finland: 'Finlande',
      France: 'France',
      Gabon: 'Gabon',
      Gambia: 'Gambie',
      Georgia: 'Géorgie',
      Ghana: 'Ghana',
      Gibraltar: 'Gibraltar',
      Greece: 'Grèce',
      Grenada: 'Grenade',
      Greenland: 'Groenland',
      Guadeloupe: 'Guadeloupe',
      Guam: 'Guam',
      Guatemala: 'Guatemala',
      Guernsey: 'Guernesey',
      Guinea: 'Guinée',
      'Guinea-Bissau': 'Guinée-Bissau',
      'Equatorial Guinea': 'Guinée équatoriale',
      Guyana: 'Guyana',
      'French Guiana': 'Guyane française',
      Haiti: 'Haïti',
      Honduras: 'Honduras',
      'Hong Kong': 'Hong Kong',
      Hungary: 'Hongrie',
      Iceland: 'Islande',
      India: 'Inde',
      Indonesia: 'Indonésie',
      Iraq: 'Irak',
      Iran: 'Iran',
      Ireland: 'Irlande',
      'Isle of Man': 'Île de Man',
      Italy: 'Italie',
      Jamaica: 'Jamaïque',
      Japan: 'Japon',
      Jersey: 'Jersey',
      Jordan: 'Jordanie',
      Kazakhstan: 'Kazakhstan',
      Kenya: 'Kenya',
      Kiribati: 'Kiribati',
      Kuwait: 'Koweït',
      Kyrgyzstan: 'Kirghizistan',
      Laos: 'Laos',
      Latvia: 'Lettonie',
      Lebanon: 'Liban',
      Lesotho: 'Lesotho',
      Liberia: 'Libéria',
      Libya: 'Libye',
      Liechtenstein: 'Liechtenstein',
      Lithuania: 'Lituanie',
      Luxembourg: 'Luxembourg',
      Macao: 'Macao',
      'North Macedonia': 'Macédoine du Nord',
      Madagascar: 'Madagascar',
      Malawi: 'Malawi',
      Malaysia: 'Malaisie',
      Maldives: 'Maldives',
      Mali: 'Mali',
      Malta: 'Malte',
      'Marshall Islands': 'Îles Marshall',
      Martinique: 'Martinique',
      Mauritania: 'Mauritanie',
      Mauritius: 'Maurice',
      Mayotte: 'Mayotte',
      Mexico: 'Mexique',
      Micronesia: 'Micronésie',
      Moldova: 'Moldavie',
      Monaco: 'Monaco',
      Mongolia: 'Mongolie',
      Montenegro: 'Monténégro',
      Montserrat: 'Montserrat',
      Morocco: 'Maroc',
      Mozambique: 'Mozambique',
      Myanmar: 'Myanmar',
      Namibia: 'Namibie',
      Nauru: 'Nauru',
      Nepal: 'Népal',
      Netherlands: 'Pays-Bas',
      'New Caledonia': 'Nouvelle-Calédonie',
      'New Zealand': 'Nouvelle-Zélande',
      Nicaragua: 'Nicaragua',
      Niger: 'Niger',
      Nigeria: 'Nigeria',
      Niue: 'Niue',
      'Norfolk Island': 'Île Norfolk',
      'Northern Mariana Islands': 'Îles Mariannes du Nord',
      Norway: 'Norvège',
      Oman: 'Oman',
      Pakistan: 'Pakistan',
      Palau: 'Palaos',
      Palestine: 'Palestine',
      Panama: 'Panama',
      'Papua New Guinea': 'Papouasie-Nouvelle-Guinée',
      Paraguay: 'Paraguay',
      Peru: 'Pérou',
      Philippines: 'Philippines',
      'Pitcairn Islands': 'Îles Pitcairn',
      Poland: 'Pologne',
      Portugal: 'Portugal',
      'Puerto Rico': 'Porto Rico',
      Qatar: 'Qatar',
      Romania: 'Roumanie',
      Russia: 'Russie',
      Rwanda: 'Rwanda',
      Réunion: 'Réunion',
      'Saint Barthélemy': 'Saint-Barthélemy',
      'Saint Helena': 'Sainte-Hélène',
      'Saint Kitts and Nevis': 'Saint-Kitts-et-Nevis',
      'Saint Lucia': 'Sainte-Lucie',
      'Saint Martin': 'Saint-Martin',
      'Saint Pierre and Miquelon': 'Saint-Pierre-et-Miquelon',
      'Saint Vincent and the Grenadines': 'Saint-Vincent-et-les-Grenadines',
      Samoa: 'Samoa',
      'San Marino': 'Saint-Marin',
      'Sao Tome and Principe': 'Sao Tomé-et-Principe',
      Senegal: 'Sénégal',
      Serbia: 'Serbie',
      Seychelles: 'Seychelles',
      'Sierra Leone': 'Sierra Leone',
      Singapore: 'Singapour',
      'Sint Maarten': 'Saint-Martin',
      Slovakia: 'Slovaquie',
      Slovenia: 'Slovénie',
      'Solomon Islands': 'Îles Salomon',
      Somalia: 'Somalie',
      'South Georgia and the South Sandwich Islands':
        'Géorgie du Sud-et-les Îles Sandwich du Sud',
      'South Sudan': 'Soudan du Sud',
      'Sri Lanka': 'Sri Lanka',
      Sudan: 'Soudan',
      Suriname: 'Suriname',
      'Svalbard and Jan Mayen': 'Svalbard et Jan Mayen',
      Swaziland: 'Eswatini',
      Sweden: 'Suède',
      Switzerland: 'Suisse',
      Syria: 'Syrie',
      Taiwan: 'Taïwan',
      Tajikistan: 'Tadjikistan',
      Tanzania: 'Tanzanie',
      Thailand: 'Thaïlande',
      'Timor-Leste': 'Timor-Leste',
      Togo: 'Togo',
      Tokelau: 'Tokelau',
      Tonga: 'Tonga',
      'Trinidad and Tobago': 'Trinité-et-Tobago',
      Tunisia: 'Tunisie',
      Turkey: 'Turquie',
      Turkmenistan: 'Turkménistan',
      Tuvalu: 'Tuvalu',
      Uganda: 'Ouganda',
      Ukraine: 'Ukraine',
      'United Kingdom': 'Royaume-Uni',
      Uruguay: 'Uruguay',
      Uzbekistan: 'Ouzbékistan',
      Vanuatu: 'Vanuatu',
      'Vatican City': 'Vatican',
      Venezuela: 'Venezuela',
      Vietnam: 'Viêt Nam',
      'Western Sahara': 'Sahara occidental',
      Yemen: 'Yémen',
      Zambia: 'Zambie',
      Zimbabwe: 'Zimbabwe',
    };
    return translations[name] || name;
  }
  onCountryChange(mode: string): void {
    this.createform.get('city')?.enable();
    this.countries = this.createform.get('country')?.value;
    this.countries = this.countries.map(
      (item: any) => this.paysList.filter((it) => it.name === item)[0]
    );

    console.log('item of countries ', this.countries);
    this.stateList.length = 0;
    // if (event.length) {
    this.countries.forEach((item: any) => {
      this.stateList.push(State.getStatesOfCountry(item.isoCode));
    });
    this.stateList = this.stateList.flat();
    for (const iterator of this.stateList) {
      iterator.name = iterator.name.replace(' Governorate', '');
    }
    this.stateList = this.stateList.map((item: any) => item.name);
    console.log('stateList ', this.stateList);
    this.mobilities = this.createform.get('city')?.value;
    if (this.mobilities != null && this.mobilities.length > 0) {
      console.log('size of mobilities ', this.mobilities.length);
      let differentItemsArray1: any[] = [];
      differentItemsArray1 = this.mobilities.filter(
        (item) => !this.stateList.includes(item)
      );
      const differentItemsArray2 = this.mobilities.filter(
        (item) => !differentItemsArray1.includes(item)
      );
      this.createform.get('city')?.setValue(differentItemsArray2);
    }
    // }
    if (this.stateList.length == 0) {
      this.stateList = [];
      mode == 'add';
      this.createform.get('city')?.setValue(null);
    }
  }
  /* get company  details */
  getCompanyById() {
    this.spinner.show();
    this.callService
      .getcallById(this.id)
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe({
        next: (res) => {
          this.spinner.hide();
          console.log('API Response:', res);
          this.jobofferDetails = res.data[0];
          this.updateDescription(this.jobofferDetails.description);
          console.log('jobofferDetails:', this.jobofferDetails);
        },
        error: () => {
          this.spinner.hide();
        },
      });
  }

  getskillsjoboffer() {
    this.callService.getskillsjoboffre(this.id).subscribe({
      next: (res: any) => {
        this.skills1 = res.data;
        console.log('skills job offer', this.skills1);
      },
      error: (error) => {
        console.log('error', error);
      },
    });
  }
  getListSkills() {
    this.callService.getSkillsCompany().subscribe({
      next: (res) => {
        this.skillsList = res.data;
        console.log('  this.skillsListdsfsf', this.skillsList);
      },
      error: (err) => {
        console.log('error', err);
      },
    });
  }
  DetailsForm(data?: any) {
    return this.formBuilder.group({
      name: [data && data.name ? data.name : '', [Validators.required]],
      post_type: [
        data && data.post_type ? data.post_type : '',
        [Validators.required],
      ],
      country: [
        data && data.country ? data.country : '',
        [Validators.required],
      ],
    });
  }

  /* unsubscribe from api */
  ngOnDestroy() {
    this.unsubscribeAll.next();
    this.unsubscribeAll.complete();
  }

  navigateToAddBareme(job_request_id: any) {
    this.router.navigate([
      '/call-offer-bareme',
      { id: job_request_id },
    ]);
  }
  // open() {
  //   // console.log("offre",offre)
  //   this.skills = [];

  //   const skillsArray = this.skills1;
  //   console.log('skillsArray', skillsArray);
  //   if (skillsArray.length !== 0) {
  //     for (let i = 0; i < skillsArray.length; i++) {
  //       for (let j = 0; j < skillsArray[i].subcategories.length; j++) {
  //         this.skills.push(skillsArray[i].subcategories[j].id);
  //       }
  //     }
  //   }
  //   console.log('skills id', this.skills);
  //   // console.log("contract type length",offre.contract_type.length)
  //   // this.contrat = [];

  //   const contratList = [
  //     { id: 1, name: 'CDI' },
  //     { id: 2, name: 'CDD' },
  //     { id: 3, name: 'SIVP' },
  //     { id: 4, name: 'Freelance' },
  //     { id: 5, name: 'autres' },
  //   ];
  //   this.createform.patchValue({
  //     id: this.jobofferDetails.id,
  //     name: this.jobofferDetails.name,
  //     city: this.jobofferDetails.city,
  //     country: this.jobofferDetails.country,
  //     skills: this.skills,
  //     post_type: this.jobofferDetails.post_type,
  //     availability: this.jobofferDetails.availability,
  //     contract_type: this.jobofferDetails.contract_type,
  //     description: this.jobofferDetails.description,
  //     salary: this.jobofferDetails.salary,
  //     tjm: this.jobofferDetails.tjm,
  //     years_of_experience: this.jobofferDetails.years_of_experience,
  //   });
  //   let data = [];
  //   for (const iterator of this.contrat) {
  //     for (const contrat of this.jobofferDetails.contract_type) {
  //       if (contrat == iterator.id) {
  //         data.push(iterator);
  //         console.log('contrat after pushcdscs', this.contrat);
  //       }
  //     }
  //   }
  //   this.createform.get('contract_type')?.setValue(data);

  //   console.log('this.updateform', this.createform);
  // }
  openModal(template: TemplateRef<any>,data?: any, mode?: string) {
    this.idCallOffer = data.id;
    console.log('data', data);
    this.createform = this.registerForm(data);
//  let data = [];
  //   for (const iterator of this.contrat) {
  //     for (const contrat of this.jobofferDetails.contract_type) {
  //       if (contrat == iterator.id) {
  //         data.push(iterator);
  //         console.log('contrat after pushcdscs', this.contrat);
  //       }
  //     }
  //   }
  //   this.createform.get('contract_type')?.setValue(data);

    this.createform.get('country')?.setValue(data.country);
    console.log('country', data.country);
    this.createform.get('city')?.setValue(data.city);
    this.createform.get('otherSkills')?.setValue(data.otherSkills);
    console.log('cityyyyyyyyyyyyyyyy', this.createform.value.city);
    this.skills = [];

    const skillsArray = this.skills1;
    console.log('skillsArray', skillsArray);
    if (skillsArray.length !== 0) {
      for (let i = 0; i < skillsArray.length; i++) {
        for (let j = 0; j < skillsArray[i].subcategories.length; j++) {
          this.skills.push(skillsArray[i].subcategories[j].id);
        }
      }
    }
    console.log('skills id', this.skills);
    this.createform.get('skills')?.setValue(this.skills);
    console.log('skillIds', this.createform);
    console.log('updatte---', this.createform.value);
    this.modalRef = this.modalService.show(template, { backdrop: 'static' });
  } 
  
  updateCALLOFFER() {
    // Traitement des skills
    this.skills = [];
    const skills = this.createform.get('skills')?.value;
    if (skills) {
      this.skills = Array.isArray(skills) ? skills : [skills];
    }
    console.log('skills', this.skills);
  
    // Traitement des autres attributs
    let otherSkills = this.createform.get('otherSkills')?.value;
    if (typeof otherSkills === 'string' && otherSkills) {
      otherSkills = otherSkills.split(',').map(skill => skill.trim());
    }
    console.log('otherSkills', otherSkills);
  
    const city = this.createform.get('city')?.value;
    const country = this.createform.get('country')?.value;
  
    const formattedCity = typeof city === 'string' ? JSON.parse(city) : city;
    const formattedCountry = typeof country === 'string' ? JSON.parse(country) : country;
  
    this.createform.patchValue({
      salary: this.createform.value.salary ? String(this.createform.value.salary) : '0',
      tjm: this.createform.value.tjm ? String(this.createform.value.tjm) : '0',
      years_of_experience: String(this.createform.value.years_of_experience),
      otherSkills: otherSkills || [],
      city: formattedCity || [],
      country: formattedCountry || []
    });
  
    // Nettoyage des valeurs nulles ou vides
    // for (let key in this.createform.value) {
    //   if (
    //     this.createform.value[key] === null ||
    //     this.createform.value[key].length === 0
    //   ) {
    //     delete this.createform.value[key];
    //   }
    // }
    
    console.log("form update", this.createform.value);
    this.spinner.show();
    this.callService
      .updateCallOffer(this.id, this.createform.value)
      .subscribe((res: any) => {
        this.spinner.hide();
        this.createform.reset();
        this.closeModal();
        this.getCompanyById();
        this. getskillsjoboffer() 
        this.toastr.success(calloffermodifie);
      });
  }
  
  close_modal_add() {
    let btnClose = document.getElementById('ModalClose_update_offre');
    this.createform.reset();
    console.log('btnClose', btnClose);
    if (btnClose) {
      btnClose.click();
    }
    // this.submitted = false;
    // this.goToAdd()
  }

  deletecalloffer(id: any) {
    Swal.fire({
      title: 'Voulez-vous vraiment désactiver cette appel d’offre ?',
      // text: "Vous ne pourrez pas revenir en arrière !",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085D6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Oui, désactivé !',
      cancelButtonText: 'Annuler ',
    }).then((result) => {
      if (result.isConfirmed) {
        this.callService.deleteCallOffer(id).subscribe({
          next: (response: any) => {
            console.log('response', response);

            console.log('response.data', response.data);
            this.toastr.success(
              'L’appel Offre a été désactivé avec succès.'
            );
            this.router.navigate(['/liste-appels-offres']);
          },
          error: (error: any) => {
            console.error('Error fetching  job offer: ', error);
          },
        });
      }
    });
  }
  activerjoboffer(id: any) {
    Swal.fire({
      title: 'Voulez-vous vraiment activer cette appel d’offre ?',
      // text: "Vous ne pourrez pas revenir en arrière !",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085D6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Oui, activé !',
      cancelButtonText: 'Annuler',
    }).then((result) => {
      if (result.isConfirmed) {
        this.callService.activerjoboffer(id).subscribe({
          next: (response: any) => {
            console.log('response', response);

            console.log('response.data', response.data);
            this.toastr.success(
              'L’offre d’emploi a été activé avec succès .'
            );
            this.router.navigate(['/liste-appels-offres']);
          },
          error: (error: any) => {
            console.error('Error fetching  job offer: ', error);
          },
        });
      }
    });
  }
  closeModal() {
    this.stateList=[];
    this.modalRef?.hide();
    this.createform.reset();

    this.file = null;
    this.fileError = '';
    this.fileExtention = '';
  }

  onMobilityChange(mode: string) {
    this.mobilities = this.createform.get('city')?.value;
    let paysLists: any[] = [];
    this.countries = this.createform.get('country')?.value;
    this.countries = this.countries.filter(async (item: any) => {
      paysLists.push(this.paysList.filter((it) => it.name === item)[0]);
    });
    let stateListAfter1: any[] = [];
    paysLists.forEach((item) => {
      let stateListAfter: any[] = [];
      stateListAfter = State.getStatesOfCountry(item.isoCode);
      let difference1: any[] = [];
      if (this.countries.length > 0) {
        difference1 = this.findDuplicates(
          this.mobilities,
          stateListAfter.map((item) => item.name)
        );
        console.log('difference1 : ', difference1.length);
        if (difference1.length == 0) {
          let index = this.countries.indexOf(item.name);
          if (index !== -1) {
            let new_array = this.countries
              .slice(0, index)
              .concat(this.countries.slice(index + 1));
            console.log('new_array is ', item.name);
            this.stateList = this.stateList.filter(
              (item: any) =>
                !stateListAfter.map((item) => item.name).includes(item)
            );

            // this.searchForm.get('country')?.setValue(new_array);
          } else {
            console.log('String not found in array.', item.name);
          }
        }
      }
    });

    console.log('stateListAfter1 ', stateListAfter1);

    //  this.stateList=stateListAfter1

    this.mobilities = this.createform.get('city')?.value;
    if (this.mobilities.length === 0 || this.stateList.length === 0) {
      this.createform.get('city')?.disable();
      mode == 'add';
      this.createform.get('country')?.setValue(null);
      mode == 'add';
      this.createform.get('city')?.setValue(null);
      this.createform.get('country')!.updateValueAndValidity();
      this.createform.get('city')!.updateValueAndValidity();
      this.stateList.length = 0;
    } else {
      /*  if(this.countries) {
        this.countries.forEach((item) => {
          console.log('item of countries ', item);
  
        });
      }*/
    }
  }
  findDuplicates(array1: any, array2: any) {
    let occurrences: any[] = [];
    let duplicates: any = [];
    for (let element of array1) {
      occurrences[element] = (occurrences[element] || 0) + 1;
    }
    for (let element of array2) {
      if (occurrences[element] && !duplicates.includes(element)) {
        duplicates.push(element);
      }
    }

    return duplicates;
  }
  onContentChange(event: any): void {
    if (event.html) {
      const sanitizedContent = DOMPurify.sanitize(event.html);
      if (sanitizedContent !== this.createform.get('description')?.value) {
        this.createform.patchValue(
          { description: sanitizedContent },
          { emitEvent: false } 
        );
      }
    }

  }
}
